import React from "react";
import moment from "moment";
import { Typography, Paper, makeStyles, Chip, Box } from "@material-ui/core";

const useCardStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: theme.shadows[2],
    },
    margin: theme.spacing(0, 1),
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    maxWidth: "350px",
    minWidth: "200px",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
      maxWidth: "220px",
    },
  },
  lightBlue: {
    backgroundColor: "#e3f2fd",
  },
  lightPink: {
    backgroundColor: "#f3e5f5",
  },
  lightLight: {
    backgroundColor: "#e8f5f3",
  },
  parrotGreen: {
    backgroundColor: "#c8f9b6",
  },
  disabledPaper: {
    filter: "grayscale(30%)",
    "&:hover": {
      transform: "none",
      boxShadow: theme.shadows[3],
    },
  },
  date: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
}));

const TimelineCard = ({ item, onClick }) => {
  let status = item.status;
  if ("Pending" === status) {
    status = "Upcoming";
  }
  const classes = useCardStyles();
  const attended = item.enrollmentStatus === "Attended";
  return (
    <Paper
      className={`${classes.paper} ${
        !["Upcoming", "Completed"].includes(status) ? classes.disabledPaper : ""
      } ${getWorkshopClass(status, classes)}`}
      onClick={onClick}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography
          style={{ fontSize: "15px", color: "#000" }}
          className={classes.date}
        >
          {moment(item.date).format("LL")}, 3:00 PM
        </Typography>

        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent={"flex-end"}
        >
          <Chip
            label={status}
            size="small"
            className="mb-2"
            color={
              status === "Completed"
                ? "primary"
                : status === "Upcoming"
                ? "secondary"
                : "default"
            }
            variant="outlined"
          />
          {item.enrollmentStatus && (
            <Chip
              label={item.enrollmentStatus}
              size="small"
              className="mb-2"
              style={{
                marginLeft: 8,
                color: attended ? "#4caf50" : "#2196f3",
                borderColor: attended ? "#4caf50" : "#2196f3",
              }}
              variant="outlined"
            />
          )}
        </Box>
      </Box>

      <Typography variant="h6" style={{ fontSize: "15px" }}>
        {item.domain}
      </Typography>

      <Typography variant="body2" style={{ fontSize: "15px" }}>
        {item.title}
      </Typography>
    </Paper>
  );
};

const getWorkshopClass = (status, classes) => {
  switch (status) {
    case "Upcoming":
      return classes.lightPink;
      break;
    case "Pending":
      return classes.lightBlue;
      break;
    case "Ongoing":
      return classes.parrotGreen;
      break;
    default:
      return classes.lightLight;
      break;
  }
};

export default TimelineCard;
